/**
 * Архив 1С, ПР3 (спецификация 22.1, решение владельца 26 О1): подписи зарплаты прошлого — одни для сервера
 * (расчёт, TG-расчётка) и приложения сотрудников (кабинет оператора, «Зарплаты» ОО и ЕО, расчётки).
 * Игры 1С и всё, что раньше 01.03.2026, уже выплачено через 1С: показываем как начисленное, в «К выплате» не входит.
 */

/** О1 (26): «1 марта мы перешли на V1» — игры раньше этой даты выплачены через 1С. Одна константа для сервера
 *  (зарплата, замок правок, /my-backlog, «За всё время», пины загрузки) и веба. */
export const CUTOFF_1C = "2026-03-01";
/** CUTOFF_1C по-русски (ДД.ММ.ГГГГ) — для текстов отказов и подписей. */
export const CUTOFF_1C_RU = `${CUTOFF_1C.slice(8, 10)}.${CUTOFF_1C.slice(5, 7)}.${CUTOFF_1C.slice(0, 4)}`;

/** Последняя игра выгрузки 1С (игры 1С: 26.09.2019–05.03.2026). Даты по неё включительно — эпоха 1С: внешние входы
 *  (виджет, МирКв, Юнифанс) на них не бронируют и слотов не показывают — там стоят игры 1С, а их снаружи не видно. */
export const LAST_1C_DATE = "2026-03-05";
/** Дата (ГГГГ-ММ-ДД…) не позже LAST_1C_DATE. Пустое и не-дата — нет (такие отказы у роутов свои). */
export function inEra1c(d: unknown): boolean {
  return typeof d === "string" && /^\d{4}-\d{2}-\d{2}/.test(d) && d.slice(0, 10) <= LAST_1C_DATE;
}

/** Подпись суммы, выплаченной через 1С (итог периода). */
export const PAID_1C_LABEL = "Начислено (выплачено через 1С)";
/** Та же подпись строкой дня (после ставки). */
export const PAID_1C_SHORT = "выплачено через 1С";
/** Подпись строки дня: своя пометка («отмена · компенсация», «отчёт не сдан»…) остаётся, «выплачено через 1С» — рядом. */
export function withPaid1c(sub: string | undefined, paid1c: boolean | undefined): string | undefined {
  return paid1c ? (sub ? `${sub} · ${PAID_1C_SHORT}` : PAID_1C_SHORT) : sub;
}
/** Такси отчёта 1С — это «доп» из 1С (У6). */
export const TAXI_1C_LABEL = "доп 1С";

/**
 * ПР8 (спецификация 22.1, Р10 «найм с 2019»): самая ранняя дата найма — одна для сервера (PUT /api/staff/:id,
 * staff/profile.ts) и веба (барабан «Дата найма» в HR). Первые игры 1С — 2019 год («Оператор не известен» —
 * 2019-09-28), раньше граница была 2020 и поднимала такой год до 2020 при простом «ОК».
 */
export const HIRED_MIN = "2019-01-01";
/** Год HIRED_MIN — первый год барабана даты найма. */
export const HIRED_MIN_YEAR = Number(HIRED_MIN.slice(0, 4));
